import { computedFrom, observable, autoinject, TaskQueue, targetContext } from "aurelia-framework";
import { ContextMenu, ContextMenuDivider } from "./widgets/action-bar/context-menu";
import { Carrier } from "../models/carrier";
import { WebApiService } from "../services/web-api-service";
import { Router } from "aurelia-router";
import { BusyService } from "../services/busy-service";
import * as moment from 'moment';
import { SecurityService } from "../services/security-service";
import { DialogService } from "aurelia-dialog";
import { CarrierStatusDialog } from "./dialogs/carrier-status-dialog";
import { CarrierDocument } from "../models/carrier-document";
import { UploadDocumentDialog } from "./dialogs/upload-document-dialog";
import { SimpleDialog } from "./dialogs/simple-dialog";
import { CarrierDocumentVersion } from "../models/carrier-document-version";
import { UpdateDocumentVersionDialog } from "./dialogs/update-document-version-dialog";
import 'jquery';

@autoinject()
export class CarrierDocuments {

    constructor(private api: WebApiService, private router: Router,
        private busyService: BusyService,
        private dialogService: DialogService,
        public securityService: SecurityService,
        private taskQueue: TaskQueue) {
        this._buildContextMenu();
    }

    activate(parameters) {
        this.parameters = parameters;

        this._loadCarrier(parameters.carrierId)
            .then(() => {
                this.loadDocuments(this.carrier.uniqueId);
            });
    }

    attached() {
        let $: any = window["$"];
        $(window).on("resize", () => this.resizeDocumentViewerHeight());

        this.resizeDocumentViewerHeight();

    }

    detached() {
        let $: any = window["$"];
        $(window).off("resize");
    }

    @observable()
    showArchivedVersions: boolean = true;
    // showArchivedVersionsChanged(newValue) {
    //     //re-select document to apply new archive flag
    //     this.selectDocument(this.selectedDocument);
    // }

    parameters: any;
    selectedDocument: CarrierDocument = undefined;
    selectedDocumentVersionsFiltered: Array<CarrierDocumentVersion> = [];
    @observable()
    selectedDocumentVersion: CarrierDocumentVersion = undefined;
    selectedDocumentVersionChanged(newValue: any, oldValue: any) {
        if (newValue == 'add_new_version') {
            this.addDocumentVersion(this.selectedDocument, oldValue && oldValue.title)
                .then(result => {
                    if (!result) {
                        setTimeout(() => {
                            this.selectedDocumentVersion = oldValue;
                        }, 0);
                    }
                });
        }
    };
    viewerPage = 1;
    viewerScale = 1.0;
    //viewerHeight: string = document.querySelector("body").offsetHeight - 159 + "px";

    scaleUp() {
        this.viewerScale += 0.25;
    }
    scaleDown() {
        this.viewerScale -= 0.25;
    }
    prevPage() {
        if (this.viewerPage > 1)
            this.viewerPage--;
    }
    nextPage() {
        if (this.viewerPage < this.selectedDocumentVersion.pageCount)
            this.viewerPage++;
    }

    @computedFrom("selectedDocument")
    get isDocumentSelected() {
        return !!this.selectedDocument && !!this.selectedDocument.documentId;
    }

    selectDocument(doc: CarrierDocument) {
        if (doc) {
            this.selectedDocument = doc;
            // this.filterVersions();
        }
    }

    newVersionButton() {
        this.addDocumentVersion(this.selectedDocument, this.selectedDocumentVersion.title);
    }

    // filterVersions(versionToSelect?: CarrierDocumentVersion) {
    //     if (!this.selectedDocument) return;
    //     this.selectedDocumentVersionsFiltered = this.selectedDocument.versions.filter(o => {
    //         return this.showArchivedVersions || !o.archive;
    //     });
    //     //this.selectedDocumentVersionsFiltered = doc.versions;
    //     this.selectedDocumentVersion = this.selectedDocumentVersionsFiltered[0];
    // }

    copyFolderPathToClipboard() {
        var val = "\\\\rz.nucorsteel.local\\root\\Carrier_Management_Portal_Data\\" + this.carrier.uniqueId;
        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        //$(dummy).css('display', 'none');
        dummy.setAttribute("id", "dummy_id");
        (<any>document.getElementById("dummy_id")).value = val;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    }

    handleDocumentThumbnailAction(document: CarrierDocument) {
        switch ((<any>event).detail.value) {
            case "upload":
                this.addDocumentVersion(document);
                break;
            case "delete":
                this.deleteDocument(document);
                break;
        }
    }

    addDocumentVersion(doc, title?) {
        //let doc = (<any>event).detail.value;
        return new Promise((resolve, reject) => {
            this.dialogService.open({
                viewModel: UploadDocumentDialog,
                model: {
                    document: doc,
                    documentType: this.selectedDocument.documentType,
                    versionCount: this.selectedDocument.versions.length,
                    carrierName: this.carrier.getCarrierName(),
                    carrierId: this.carrier.id,
                    carrierGuid: this.carrier.uniqueId
                }
            }).whenClosed((result) => {
                if (!result.wasCancelled) {
                    var uploadResult = result.output;
                    if (uploadResult && uploadResult.documentVersion) {
                        doc.versions.unshift(uploadResult.documentVersion);
                        this.selectedDocumentVersion = uploadResult.documentVersion;
                        // this.filterVersions(uploadResult.documentVersion);
                        resolve(true);
                    } else {
                        resolve();
                    }
                } else {
                    resolve();
                }
            });
        });

    }

    carrier: Carrier;
    private _loadCarrier(id) {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierById", { carrierId: id })
            .then((result) => {
                this.carrier = Object.assign(new Carrier(), JSON.parse(result.response));

                //set the page title
                this.router.currentInstruction.config.navModel.setTitle(this.carrier.legalName + " - Documents");
                this.router.updateTitle();
            }).finally(() => {
                this.busyService.off();
            });
    }

    documents: Array<CarrierDocument>;

    private loadDocuments(carrierGuid) {
        return this.api.get("Carriers", "GetCarrierDocuments", { carrierGuid: carrierGuid })
            .then((result) => {
                let docsInfo = JSON.parse(result.response);
                let documents = [];
                //use actual model instance
                docsInfo.forEach(docInfo => {
                    let doc = Object.assign(new CarrierDocument(), docInfo);
                    documents.push(doc);
                });
                this.documents = documents;
                //don't auto-select because it's causing too long delays when user doesn't need to see the first document.
                //if (this.documents.length) {
                //    this.selectDocument(this.documents[0]);
                //    //this.selectedDocument = this.documents[0];
                //    //this.selectedDocumentVersionsFiltered = this.selectedDocument.versions;
                //    //this.selectedDocumentVersion = this.selectedDocument.versions[0];
                //}
            });
    }

    addDocument() {
        this.dialogService.open({
            viewModel: UploadDocumentDialog,
            model: { document: null, carrierName: this.carrier.getCarrierName(), carrierId: this.carrier.id, carrierGuid: this.carrier.uniqueId }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    var uploadResult = result.output;
                    this.documents.push(uploadResult.document);
                    setTimeout(() => {
                        this.selectDocument(uploadResult.document);
                        //this.selectedDocument = uploadResult.document;
                        //this.selectedDocumentVersionsFiltered = this.selectedDocument.versions;
                        //this.selectedDocumentVersion = uploadResult.documentVersion;
                        setTimeout(() => {
                            var el = (<any>this.selectedDocument).element;
                            if (el) {
                                el.scrollIntoView();
                            }
                        }, 50);
                    }, 50);
                }
            });
    }

    thumbnailContainer: any;
    documentContainer: any;
    private VIEWER_MIN_HEIGHT: number = 200;

    resizeDocumentViewerHeight() {
        let $: any = window["$"];
        let $thumbnailContainer = $(this.thumbnailContainer);
        let $documentContainer = $(this.documentContainer);

        var footerHeight = $("footer").outerHeight(true);
        var targetHeight = $(window).height() - $thumbnailContainer.offset().top - footerHeight;
        if (targetHeight < this.VIEWER_MIN_HEIGHT) {
            targetHeight = this.VIEWER_MIN_HEIGHT;
        }

        if ($thumbnailContainer.height() !== targetHeight) {

            // Use this information for debugging resize issues
            //$log.trace("RESIZING GRID");
            //$log.trace("==============================");
            //$log.trace(`FOOTER HEIGHT: ${footerHeight}`);
            //$log.trace(`WINDOW HEIGHT: ${$(window).height()}`);
            //$log.trace(`DOCUMENT HEIGHT: ${$(document).height()}`);
            //$log.trace(`GRID CONTAINER offset().top: ${$gridContainer.offset().top}`);
            //$log.trace(`NEW GRID HEIGHT: ${targetHeight}`);


            //resize the containers
            $thumbnailContainer.stop().animate(
                { height: targetHeight },
                {
                    progress: function () {
                        //widget.resize();
                    }, duration: 'fast'
                });
            $documentContainer.stop().animate(
                { height: targetHeight - 33 },
                {
                    progress: function () {
                        //widget.resize();
                    }, duration: 'fast'
                });
        }
    }

    updateDocumentVersion(version: CarrierDocument) {

        this.dialogService.open({
            viewModel: UpdateDocumentVersionDialog,
            model: { carrierGuid: this.carrier.uniqueId, documentVersion: this.selectedDocumentVersion }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    Object.assign(this.selectedDocumentVersion, result.output);
                    // this.filterVersions(this.selectedDocumentVersion);
                }
            });
    }

    deleteDocumentVersion(version: CarrierDocument) {
        let title = "Delete document version";
        let message = "Do you want to permanently delete the selected document version?\n\nThis cannot be undone.";
        if (version.isLinked) {
            title = "Delete linked document version";
            message = "WARNING: This document is linked to one or more requirements.  Do you want to permanently delete the selected document version and any associated links?\n\nThis cannot be undone.";
        }

        this.dialogService.open({
            viewModel: SimpleDialog,
            model: {
                title: title,
                icon: "fa-exclamation-triangle",
                message: message,
                buttons: ["Yes", "No"]
            }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "Yes") {
                        this.busyService.on();
                        let indexToRemove = this.selectedDocument.versions.indexOf(this.selectedDocumentVersion);
                        let param = this.selectedDocumentVersion as any;
                        param.carrierGuid = this.carrier.uniqueId;
                        this.api.post("document", "DeleteDocumentVersion",
                            param
                        )
                            .then(result => {
                                this.selectedDocument.versions.splice(indexToRemove, 1);
                                // this.filterVersions();
                            })
                            .finally(() => {
                                this.busyService.off();
                            });
                    }
                }
            });
    }

    deleteDocument(selectedDocument: CarrierDocument) {
        let title = "Delete document";
        let message = `Do you want to permanently delete the selected document${+ this.selectedDocument.versions.length ? " and all versions" : ""}?\n\nThis cannot be undone.`;
        if (selectedDocument.isLinked) {
            title = "Delete linked document";
            message = "WARNING: This document is linked to one or more requirements.\n" + message;
        }
        title += " " + (this.selectedDocument.versions.length ? " and all versions" : "");
        this.dialogService.open({
            viewModel: SimpleDialog,
            model: {
                title: title,
                icon: "fa-exclamation-triangle",
                message: message,
                buttons: ["Yes", "No"]
            }
        })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "Yes") {

                        //strip out properties that cause circular references
                        let doc = {
                            carrierGuid: this.carrier.uniqueId,
                            documentId: this.selectedDocument.documentId,
                            versions: this.selectedDocument.versions.map(o => {
                                return {
                                    documentId: o.documentId,
                                    documentVersionId: o.documentVersionId
                                };
                            })
                        };

                        this.busyService.on();
                        this.api.post("document", "DeleteDocument", doc)
                            .then(result => {
                                //reload documents
                                this.loadDocuments(this.carrier.uniqueId);
                            })
                            .finally(() => {
                                this.busyService.off();
                            });
                    }
                }
            });
    }


    private _buildContextMenu() {
        this.actionBarMenu = new ContextMenu();

        this.actionBarMenu.items.push({
            caption: "Refresh", securityRole: 'view',
            onClick: () => {
            }
        });

        //this.actionBarMenu.items.push(new ContextMenuDivider());
    }
    actionBarMenu: ContextMenu;

}